import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { RemoveSeparationButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { createSeparationCountSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { createSieveSizeCaptionGetter, SieveSizeId } from 'Data/ViewModels/Equipment/ISieveSize';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, TextOutput } from '../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../../Layout';

let SeparationDuringSievingPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  // Heading text - with a numeric suffix if the test has multiple separations
  const index = namePrefix?.match(/\.Separation\./g)?.length ?? 0;
  const separationCount = useSelector(createSeparationCountSelector(createWorksheetSelector!));
  const separationHeading = separationCount > 1 ? `Separation ${index + 1}` : 'Separation';

  const isWholePortion = namePrefix?.endsWith('WholePortion') ?? false;
  const isWashed = useSelector(pipe(createWorksheetSelector!(`Washing.IsWashed`), valueOrDefault(false)));
  const separatingSieveSizeId: SieveSizeId = useSelector(createWorksheetSelector!('Separation.SeparatingSieveSizeId'));
  const separatingSieveSizeCaption = useSelector(
    pipe(
      createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      createSieveSizeCaptionGetter(separatingSieveSizeId),
      valueOrDefault('N/A')
    )
  );
  return (
    <PageSection heading={separationHeading}>
      {/* Separation details from the coarse portion sieving section. */}
      <ListFieldSection>
        <Field input={<TextOutput />} name="Separation.SeparatingSieveSizeId" value={separatingSieveSizeCaption} />
        {isWholePortion && <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />}
        {isWholePortion && isWashed && (
          <Field input={<TextOutput />} name="Washing.WashedDryMass" label="Specimen Washed Dry Mass" />
        )}
        <Field input={<TextOutput />} name="Separation.CoarsePortion.Masses.DryMass" />
        <Field input={<TextOutput />} name="Separation.FinePortion.Masses.DryMass" />
      </ListFieldSection>

      {/* Subsampling of fine portion. */}
      <ListFieldSection heading="Fine Portion Subspecimen Mass">
        <NamePrefixModifier appendNamePrefix="Separation.FinePortion.Subspecimen.Masses">
          <WorksheetBalanceFieldSet name="MassMeasurement.Equipment.DryMassBalance" />
          <Field input={<NumericInput />} name="MassMeasurement.TareMass" />
          <Field input={<NumericInput />} name="MassMeasurement.TareAndDryMass" />
          <Field input={<TextOutput />} name="DryMass" />
        </NamePrefixModifier>
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix="Separation">
        <div>
          <RemoveSeparationButton />
        </div>
      </NamePrefixModifier>
    </PageSection>
  );
};

SeparationDuringSievingPageSection = withInjectedProps(SeparationDuringSievingPageSection);

export { SeparationDuringSievingPageSection };
export default SeparationDuringSievingPageSection;
